var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeviceManagementLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 44,
    viewBox: "0 0 50 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 37.3398H48.58V37.5098C48.5721 38.7034 48.0924 39.8454 47.2456 40.6866C46.3988 41.5278 45.2536 41.9999 44.06 41.9998H5.52C4.3264 41.9999 3.18124 41.5278 2.33444 40.6866C1.48763 39.8454 1.00792 38.7034 1 37.5098V37.3398Z",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8899 38.6401H27.8899",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45996 12.2998H43.12C43.6504 12.2998 44.1591 12.5105 44.5342 12.8856C44.9092 13.2607 45.12 13.7694 45.12 14.2998V37.2998H4.45996V14.2998C4.45996 13.7694 4.67067 13.2607 5.04575 12.8856C5.42082 12.5105 5.92953 12.2998 6.45996 12.2998Z",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7 16.0098H7.96997V37.3298H41.7V16.0098Z",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3701 4.14C18.8101 2.13 22.0001 1 25.0001 1C28.0001 1 31.3201 2.2 32.7001 4.32",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3201 7.49987C20.9124 6.85656 21.6381 6.35051 22.4466 6.01712C23.255 5.68374 24.1265 5.53109 25.0001 5.56987C26.8701 5.56987 28.8801 6.30987 29.7301 7.56987",
    stroke: "#0053A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.58,
    height: 43.03,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceManagementLogoBlue);
export default __webpack_public_path__ + "static/media/device-management-logo-blue.7cbf1ddb2070a1c29c2250bfa72a5caf.svg";
export { ForwardRef as ReactComponent };